<template>
<div>
    <div class="nav" id="container">
        <nav class="main-nav hc-nav hc-nav-1">
            <ul class="first-nav">
                <li class="search">
                <div class="form-container">
                    <h4 class="subtitle">上海交大 生命学院</h4>
                    <input type="text" name="search" placeholder="查找会议室 / Find Meeting Rooms"/>
                </div>
              </li>
            </ul>
            <menubar class="ori" v-for="(menuitem,index) in menulist" :menulist="menuitem" :key="index"/>
            <ul v-if="false" class="bottom-nav">
                <li v-for="(b,index) in bottomNavList" :key="index" class="bottom">
                    <a href="#">{{ b.title }}</a>
                </li>
            </ul>
        </nav>
     </div>
      
    </div>
</template>
<style>
@import '../../src/assets/css/demo.css';
.hc-offcanvas-nav h2,.hc-offcanvas-nav .first-nav{color:#fff;text-align: center;background:#2980B9;border-radius:0 0 0.3em 0.3em;}
h4.subtitle{text-align:center;color:rgba(255,255,255,0.6);margin:-1em 0px 1em 0px;font-family: KaiTi}
</style>

<script>
import menubar from '@/components/menu.vue'
export default{
    name:'navi',
    props:{levelOpen:Boolean,state:Object,menulist:{type:Array,default:()=>{return [{name:'home'}];}}},
    data:function(){
        return {
            bottomnav:[
                {title:'登陆',needLogin:false},
                {title:'注册',needLogin:false},
                {title:'我的',needLogin:true},
                {title:'注销',needLogin:true},
            ],
            defaultData :{
                maxWidth: false,
                customToggle: $('.navToggle'),
                navTitle: '&#10016 智慧会议室 &#10016',
                levelTitles: true,
                pushContent: "#app",
                levelOpen:'overlap',
                closeLevels: false,
                position:'left',
                insertBack:-1,
                insertClose:false,
                labelClose:'关闭',
                labelBack:'返回',
                nav_container:'',
                levelSpacing:20
            },
            mainNav:null,
            menuDataChange:false,
        }
    },
    computed:{
        user(){
            return this.$store.state.user
        },
        bottomNavList(){
            let a=[]
            this.bottomnav.forEach(e => {
                if(e.needLogin^this.user.id){a.push(e)}
            });
            return a
        },
    },
    components:{
        menubar
    },
    methods:{
        logu:()=>{console.log('user1',this.user)},
    },
    watch:{
        levelOpen(){
            this.defaultData.levelOpen=this.levelOpen?'expand':'overlap'
            this.mainNav.update(this.defaultData)
            this.mainNav.open()
        },
        menulist(){
            var _this=this
            this.$nextTick(
                function(){
                    _this.mainNav.update(_this.defaultData,true)
                    $('a.menuButton').unbind('click')
                    $('a.menuButton').click(
                        function(){
                            console.log(this.attributes.to.value)
                            if(this.attributes.to.value){
                                _this.$router.push(this.attributes.to.value)
                                _this.mainNav.close()
                            }
                        }
                    )
                }
            )
        }
    },
    mounted(){
        var _this=this
        var $main_nav = $('.main-nav');
        this.defaultData.customToggle=$('.navToggle')
        this.defaultData.levelOpen=this.levelOpen?'expand':'overlap'
        console.log(this.levelOpen,this.defaultData)
        // call our plugin
        this.mainNav=$main_nav.hcOffcanvasNav(this.defaultData);
        $('a.menuButton').click(
            function(){console.log(this.attributes.to.value)
                if(this.attributes.to.value)
                {_this.$router.push(this.attributes.to.value)
                _this.mainNav.close()}
            }
        )
        $('input[name=search]').bind('input propertychange',i=>{this.$store.commit('setSearch',i.target.value);})
    }
}
</script>